/** Internal helper imports here ... */
// import { TickerBoard } from "ticker-board";
import "../helpers/ticker-board.min";

const TickerBoardJS = (() => {
  const tickerBoard = (boardElement, messages, wordSize, totalItems) => {
    const board = new Board(boardElement, {
      count: totalItems,
      size: wordSize,
      delay: 5,
    });

    board.updateMessages(messages);
  };

  const longestStrInArray = (arra) => {
    let max_str = arra[0].length;
    let ans = arra[0];
    for (let i = 1; i < arra.length; i++) {
      const maxi = arra[i].length;
      if (maxi > max_str) {
        ans = arra[i];
        max_str = maxi;
      }
    }
    return ans.length;
  };

  const tickerBoardInit = () => {
    const tickerBoardSection = document.querySelectorAll(".ticker-board")[0];
    const tickerBoardData = document.querySelectorAll(".ticker-board__data");

    if (tickerBoardData.length) {
      Array.from(tickerBoardData).forEach((board, index) => {
        let contentElement =
          board.nextElementSibling.querySelector(".ticker-board-list");

        if (!contentElement) {
          contentElement = board.nextElementSibling.querySelector(".board");
        }

        const contentList = Array.from(board.children).map((x) => x.innerText);
        let longestListWord = longestStrInArray(contentList);
        if (index !== tickerBoardData.length - 1) {
          longestListWord++;
        }

        const totalItems = board.children.length;

        tickerBoard(contentElement, contentList, longestListWord, totalItems);

        setInterval(() => {
          tickerBoardSection.classList.remove("animation-begin");
          tickerBoardSection.classList.add("animation-finished");
        }, 6000);
      });
    }
  };

  const createObserver = () => {
    let observer;
    const tickerBoardSection = document.querySelectorAll(".ticker-board")[0];

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    };

    observer = new IntersectionObserver(handleIntersect, options);

    if (tickerBoardSection) {
      observer.observe(tickerBoardSection);
    }
  };

  const handleIntersect = (entries, observer) => {
    const tickerBoardSection = document.querySelectorAll(".ticker-board")[0];
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (
          tickerBoardSection.classList.contains("animation-finished") ||
          tickerBoardSection.classList.contains("animation-begin")
        ) {
          tickerBoardSection.classList.remove("animation-begin");
          tickerBoardSection.classList.remove("animation-finished");
          tickerBoardInit();
          observer.unobserve(tickerBoardSection);
        }
      }
      observer.observe(tickerBoardSection);
    });
  };

  const init = () => {
    createObserver();
  };

  return { init };
})();

export default TickerBoardJS;
